import { GetProjectsByCustomerId, GetProjectsByCustomerIdToken } from "$src/application/customers/queries/GetProjectsByCustomerId";
import type { GroupedProjectsResult} from "$src/application/customers/queries/GetProjectsByCustomerId";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

interface FetchCustomerProjectsParams {
    queryKey: ['customerProjects', number, number, number];
}

async function fetchCustomerProjects({ queryKey }: FetchCustomerProjectsParams): Promise<GroupedProjectsResult> {
    const [_, groupStoreId, customerId, pageNumber] = queryKey;
    const query = container.resolve<GetProjectsByCustomerId>(GetProjectsByCustomerIdToken);
    return query.execute(groupStoreId, customerId, pageNumber );
}

export function useCustomerProjects(groupStoreId: number, customerId: number, pageNumber: number) {
    return useQuery<GroupedProjectsResult, Error, GroupedProjectsResult,  ['customerProjects', number, number, number]>(
        ['customerProjects', groupStoreId, customerId, pageNumber], 
        fetchCustomerProjects,
        {
            staleTime: 30000,
            cacheTime: 60000,
        }
    );
}
